export const environment = {
  production: true,
  apiUrl: 'https://leadbob.io/api/v1',
  baseUrl: 'https://leadbob.io',
  socketPath: '/api/socket.io/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts